import { render, staticRenderFns } from "./hik-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=template&id=1f2d0d15&"
import script from "./hik-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=script&lang=js&"
export * from "./hik-set-driver-vehicleinfo-registrationnum-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports